exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* H5 页面公共样式（移动端） */\n.h5-page {\n  min-height: 100vh;\n  background: #f5f5f5;\n  padding-bottom: 70px;\n}\n.h5-header {\n  position: sticky;\n  top: 0;\n  z-index: 99;\n  background: #fff;\n  padding: 14px 16px;\n  font-size: 17px;\n  font-weight: 600;\n  border-bottom: 1px solid #e8e8e8;\n}\n.h5-body {\n  padding: 12px;\n}\n.h5-card {\n  background: #fff;\n  border-radius: 10px;\n  padding: 14px;\n  margin-bottom: 12px;\n}\n", ""]);

// exports
